import { runPostTypesConfigSync } from '../../postTypes'

const messages = {
    notFoundNotAvailable: (p = {}) => {
        const { typeText = 'a tartalom', user } = p
        return `Ez ${typeText} ${user?._id ? 'már ' : ''}nem elérhető`
    },
    notFoundLoginText: 'Jelentkezz be a fiókodba, mert egyes oldalak csak bejelentkezés után láthatók, ha van hozzájuk jogosultságod',
    thereAreNoEntries: 'Nincsenek bejegyzések',
    cookieShortDesc: 'A weboldalon cukrász álláshirdetések mellett sütik (cookie) is találhatóak, a jobb felhasználói élmény érdekében. További információ:',
    leaveWarningMessage: 'Az oldal elhagyásával a módosításaid elvesznek. Biztosan ezt szeretnéd?',
    preventClickAgain: 'Az oldal betöltése folyamatban...',
    preventClickDone: 'Ez az oldal már betöltődött',
    offlineWarning: 'Nincs internet kapcsolat',
    onlineAgain: 'Az internetkapcsolat helyreállt',
    newReleaseWarningContent: 'A VLM alkalmazás frissült, a további rendes működéshez az oldal újratöltése szükséges',
    slowNetworkWarning: 'Lassú az internetkapcsolat',
    outdatedBrowserWarning: 'Elavult böngészőt használsz, frissítsd a legjobb élmény érdekében',
    ...runPostTypesConfigSync({ action: 'getConstants', rKey: 'messages' }).reduce((a, v) => {
        return { ...a, ...v }
    }, {})
}

export default messages
